import { StyleSheet } from "react-native";
import { theme } from "@lookiero/sty-psp-ui";

const style = () => {
  const { colorBorderInteractive } = theme();

  return StyleSheet.create({
    divider: {
      backgroundColor: colorBorderInteractive,
      height: 1,
    },
  });
};

export { style };
